import { render, staticRenderFns } from "./InvestmentContactsAdd.vue?vue&type=template&id=94ea5c52"
import script from "./InvestmentContactsAdd.vue?vue&type=script&lang=js"
export * from "./InvestmentContactsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports